<template>
  <div class="wrapper-container-invoice">
    <div v-if="modal" class="fondo" @click="closeModal(1)">
      <!-- <div class="modal" v-if="modal"> -->
      <div v-if="modal" class="wrapper-modal">
        <button
          title="Close"
          type="button"
          class="mfp-close"
          @click="closeModal(1)"
        >
          ×
        </button>
        <div class="actual-state">
          <p class="title-state">Estado actual:</p>
          <p class="tag-state">
            <el-tag
              size="medium"
              :color="saleState[data.venta.estado]?.color"
              effect="dark"
            >
              {{ saleState[data.venta.estado].state }}
            </el-tag>
            <br />
          </p>
        </div>
        <p class="title-state-change">Cambiar por:</p>
        <div
          v-for="(item, index) in saleStateShort"
          :key="index.item"
          class="state-content"
        >
          <p v-if="item.id != data.venta.estado" @click="updateState(index)">
            <el-tag size="medium" :color="item.color" effect="dark">
              {{ item.state }}
            </el-tag>
            <br />
          </p>
        </div>
      </div>
    </div>
    <div v-if="modal2" class="fondo" @click="closeModal(2)">
      <!-- <div class="modal" v-if="modal"> -->
      <div v-if="modal2" class="wrapper-modal">
        <button
          title="Close"
          type="button"
          class="mfp-close"
          @click="closeModal(2)"
        >
          ×
        </button>
        <div v-if="data.venta.delivery_status_id !== null" class="actual-state">
          <p class="title-state">Estado actual:</p>
          <p class="tag-state">
            <el-tag
              size="medium"
              :color="shippingState[data.venta.delivery_status_id - 1]?.color"
              effect="dark"
            >
              {{ shippingState[data.venta.delivery_status_id - 1].state }}
            </el-tag>
            <br />
          </p>
        </div>
        <div v-else class="actual-state">
          <p class="title-state">Estado actual:</p>
          <p class="tag-state text-center">No tiene un estado asignado</p>
        </div>
        <p class="title-state-change">Cambiar por:</p>
        <div
          v-for="(item, index) in shippingState"
          :key="index.item"
          class="state-content"
        >
          <p
            v-if="item.id != data.venta.delivery_status_id"
            @click="updateShippingState(item.id)"
          >
            <el-tag size="medium" :color="item.color" effect="dark">
              {{ item.state }}
            </el-tag>
            <br />
          </p>
        </div>
      </div>
    </div>
    <nav class="flex wrapper-invoice-nav" aria-label="Breadcrumb">
      <ol class="flex items-center space-x-4">
        <li>
          <div>
            <router-link to="/" class="text-gray-400 hover:text-gray-500">
              <svg
                class="flex-shrink-0 h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                />
              </svg>
              <span class="sr-only">Home</span>
            </router-link>
          </div>
        </li>
        <li>
          <div class="flex items-center">
            <svg
              class="flex-shrink-0 h-5 w-5 text-gray-300"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
              aria-hidden="true"
            >
              <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
            </svg>
            <router-link
              to="/ventas/listado"
              class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
            >
              Listado de ventas
            </router-link>
          </div>
        </li>
        <li>
          <div class="flex items-center">
            <svg
              class="flex-shrink-0 h-5 w-5 text-gray-300"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
              aria-hidden="true"
            >
              <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
            </svg>
            <p
              v-if="tiendaData && data"
              class="ml-4 text-sm font-medium text-gray-500"
            >
              No. {{ data.venta.id }}
            </p>
          </div>
        </li>
      </ol>
    </nav>
    <div
      v-loading="!stateDataOrder"
      element-loading-spinner="el-icon-loading"
      element-loading-text="Cargando información..."
      element-loading-background="rgba(245, 247, 250, 0.96)"
      class="main-container-invoice"
    >
      <div class="box wrapper-invoice">
        <div
          v-if="deliveryData !== null"
          class="box-body"
          style="min-height: 400px"
        >
          <section v-if="tiendaData && data" class="section-normal">
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-xs-12 invoice-header">
                <div class="col-sm-4 col-sm-12 col-xs-12 invoice-col">
                  <div class="title-container">
                    <h1 class="main-title">Información venta</h1>
                    <p>No. {{ data.venta.id }}</p>
                    <span v-if="data.usuario != 30866" class="share">
                      <strong style="font-weight: bold">Compartir: </strong>
                      <el-tooltip
                        v-model="tooltip"
                        content="Link copiado!!"
                        placement="bottom"
                        effect="light"
                        :manual="true"
                      >
                        <span class="copy-link" @click="copyLink">
                          Copiar link de venta
                        </span>
                      </el-tooltip>
                    </span>
                    <p>
                      <strong style="font-weight: bold">
                        Canal de venta:
                      </strong>
                      <span :style="getChannelStyle(data.venta.canal)">
                        {{ getChannelName(data.venta.canal) }}
                      </span>
                    </p>
                  </div>
                  <div class="content-right">
                    <img
                      loading="lazy"
                      class="logo-store"
                      :src="`${this.$store.state.urlKomercia}/logos/${tiendaData.logo}`"
                    />
                  </div>
                  <!-- <p class="date-time">
                  {{ data.venta.created_at | moment("YYYY-MM-DD, h:mm:ss a")}}
                  {{moment(data.venta.created_at)
                  .startOf("hour")
                  .fromNow()}}
                </p>-->
                </div>
              </div>
              <br />
            </div>
            <div class="row invoice-info">
              <div class="flex flex-row items-center">
                <p class="mr-2">{{ $t("text_ventas_state_sales") }}</p>
                <el-tag
                  size="medium"
                  :color="saleState[data.venta.estado]?.color"
                  effect="dark"
                >
                  {{ saleState[data.venta.estado].state }}
                </el-tag>
              </div>
              <p class="pull-right">
                <b>Fecha venta: {{ data.venta.fecha }}</b>
              </p>
              <p>
                <b>Hora: {{ data.venta.created_at | moment("h:mm:ss a") }}</b>
                <span v-if="data.venta.takeout">{{ data.venta.takeout }}</span>
              </p>
            </div>
            <br />
            <br />
            <div class="row">
              <div
                v-if="data.productos.length > 0"
                class="col-xs-12 table-responsive"
              >
                <TableProducts :data="data" :is-quotation="!!isQuotation" />
              </div>
              <div v-else>
                <div
                  v-if="productDataHoko && data.mensajes.length > 0"
                  class="col-xs-12 table-responsive"
                >
                  <p class="main-title">
                    Compra dropshipping (Hoko)
                    <i class="el-icon-refresh" @click="getproductHoko" />
                  </p>
                  <div>
                    <div
                      v-if="productDataHoko.delivery_state"
                      class="mt-4 flex flex-row items-center"
                    >
                      <p
                        v-if="productDataHoko.delivery_state"
                        class="title_payments"
                      >
                        Estado del proceso con Hoko:
                      </p>
                      <el-tag
                        size="medium"
                        :color="
                          saleStateHoko[productDataHoko.delivery_state]?.color
                        "
                        class="tag-state ml-2"
                      >
                        {{
                          $t(
                            saleStateHoko[productDataHoko.delivery_state].state
                          )
                        }}
                      </el-tag>
                    </div>
                    <div
                      v-if="productDataHoko.courier_id"
                      class="mt-4 flex flex-row items-center"
                    >
                      <p class="title_payments">Estado del proceso con Hoko:</p>
                      <div class="ml-2">
                        <p v-if="productDataHoko.courier_id == 21">
                          Mensajería MEDELLIN RR
                        </p>
                        <p v-else-if="productDataHoko.courier_id == 44">
                          Envía E-commerce CR
                        </p>
                        <p v-else-if="productDataHoko.courier_id == 45">
                          Envía E-commerce CR
                        </p>
                      </div>
                    </div>
                    <!-- hoko -->
                    <div
                      v-if="data.mensajes && data.mensajes.length > 0"
                      class="mt-4"
                    >
                      <a
                        class="btn_url"
                        :href="`https://hoko.com.co/admin/resources/orders/${parseInt(
                          data.mensajes[0].mensaje
                        )}`"
                        target="_blank"
                        title="Ver detalle de la orden en la página de Hoko"
                      >
                        Ver detalle de la orden Hoko
                      </a>
                    </div>
                  </div>
                </div>
                <div v-else-if="data.venta.canal === '6'">
                  <TableProductsShopify :data="dataShopify" />
                </div>
                <div v-else>
                  <p>
                    Falta información para mostrar el detalle de la compra, por
                    favor contactar al cliente
                  </p>
                </div>
              </div>
              <div v-if="!!isQuotation" class="quotation__actions">
                <div class="col-xs-12">
                  <el-button
                    type="primary"
                    class="btn btn-success pull-right"
                    @click="createOrder"
                  >
                    <i class="ti-check-box"></i> Finalizar cotización
                  </el-button>
                </div>
              </div>
            </div>
            <div class="row invoice-payments">
              <div>
                <div v-if="!isQuotation" class="pay-method">
                  <p v-if="choicePayment" class="lead">Método de pago:</p>
                  <div
                    v-if="choicePayment"
                    class="checkout_summary_data_payments_list"
                  >
                    <div class="checkout_summary_data_payments_item">
                      <div>
                        <h4
                          v-if="choicePayment && choicePayment.title"
                          class="title_payments"
                        >
                          {{ choicePayment.title }}
                        </h4>
                        <p v-if="choicePayment" class="subtitle_payments">
                          {{ choicePayment.description }}
                        </p>
                        <div
                          v-if="choicePayment && choicePayment.image"
                          class="mt-4"
                        >
                          <div>
                            <img
                              loading="lazy"
                              :src="choicePayment.image"
                              alt="Imagen método de pago"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- comentarios para WhatsApp -->
                  <div v-if="data.usuario == 30866">
                    <p
                      v-if="data.mensajes.length"
                      class="text-muted well well-sm no-shadow"
                      style="margin-top: 10px"
                    >
                      <strong>Comentarios adicionales:</strong>
                      <br />
                      Venta generada por
                      <i class="fab fa-whatsapp"></i>WhatsApp
                    </p>
                  </div>
                  <!-- venta por Shopify -->
                  <div v-else-if="data.venta.canal === '6'">
                    <p
                      class="text-muted well well-sm no-shadow"
                      style="margin-top: 10px"
                    >
                      <strong>Venta generada:</strong>
                    </p>
                    <img
                      loading="lazy"
                      class="mt-1"
                      src="../assets/Shopify_Logo.png"
                      alt="logo Shopify"
                      :width="130"
                    />
                  </div>
                  <!-- mensajes para los productos -->
                  <template v-else>
                    <div
                      v-if="data.mensajes && data.mensajes.length > 0"
                      class="bg-[#F2EFFF] rounded-lg px-3 py-4 mt-3 flex flex-row"
                    >
                      <img
                        loading="lazy"
                        src="../assets/comment.png"
                        class="max-h-[40px] max-w-[45px]"
                        alt="IconComment"
                        width="45"
                        height="40"
                      />
                      <p class="text-muted well well-sm no-shadow ml-3">
                        <strong>Comentarios adicionales:</strong>
                        <br />
                        {{ data.mensajes[0].mensaje }}
                      </p>
                    </div>
                  </template>
                </div>
                <!-- <div class="shipping" v-if="mensajerosurbanos">
                  <p class="lead">
                    Método de envío:
                  </p>
                  <div class="shipping__data">
                    <div class="shipping__header">
                      <p class="title_shipping">Mensajeros Urbanos</p>
                      <p class="subtitle_payments">
                        Tú has seleccionado Mensajeros Urbanos para enviar tus
                        productos
                      </p>
                    </div>
                    <el-timeline :reverse="false" v-if="mensajerosurbanosLogs">
                      <el-timeline-item
                        v-for="(activity, index) in mensajerosurbanosLogs"
                        :key="index"
                        :type="getMUState(activity).type"
                        :timestamp="activity.date"
                      >
                        {{ getMUState(activity).label }}
                        <p class="text-normal">
                          {{ activity.mensajero }} - {{ activity.phone }}
                        </p>
                      </el-timeline-item>
                    </el-timeline>
                  </div>
                </div> -->
              </div>
              <div>
                <div>
                  <div v-if="subtotal" class="row_value">
                    <p style="width: 50%">
                      <strong>Subtotal:</strong>
                    </p>
                    <p>{{ subtotal | formatCurrency(idCountryStore) }}</p>
                  </div>
                  <div class="row_value">
                    <p>
                      <strong>Envío:</strong>
                    </p>
                    <p>
                      {{
                        data.venta.costo_envio | formatCurrency(idCountryStore)
                      }}
                    </p>
                  </div>
                  <div v-if="data.venta.descuento > 0" class="row_value">
                    <p style="width: 50%">
                      <strong>Descuento:</strong>
                    </p>
                    <p>
                      -
                      {{
                        data.venta.descuento | formatCurrency(idCountryStore)
                      }}
                    </p>
                  </div>
                  <div
                    v-if="data.venta.cupon && data.venta.cupon !== 'null'"
                    class="row_value"
                  >
                    <p style="width: 50%">
                      <strong>Cupón:</strong>
                    </p>
                    <p>{{ data.venta.cupon }}</p>
                  </div>
                  <div class="row_value">
                    <p>
                      <strong>Total:</strong>
                    </p>
                    <p>
                      {{ data.venta.total | formatCurrency(idCountryStore) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="
                data &&
                data.venta.mi_paquete_pre_envio &&
                data.venta.mi_paquete_pre_envio.length &&
                data.venta.mi_paquete_pre_envio[0].carritos_id
              "
              class="checkout_summary_data_payments_list"
            >
              <div v-if="stateMipaquete" class="content-mipaquete">
                <div class="flex flex-row items-end">
                  <p class="mr-4">Esta compra tiene un pre-envio con</p>
                  <img
                    loading="lazy"
                    src="https://centrodenovedades.mipaquete.com/static/media/imagotype.3d75c2b1.svg"
                    alt="Imagen de logo mipaquete.com"
                    :width="80"
                  />
                </div>
                <div>
                  <router-link
                    :to="`/integraciones/mi-paquete?order_id=${data.venta.id}&pre_envio=true&order_mipaquete=${order_mipaquete}`"
                    class="flex flex-row items-end mx-5 my5 btn_mipaquete cursor-pointer"
                  >
                    <p class="mr-3">Aceptar pre-envío</p>
                    <img
                      loading="lazy"
                      src="https://app.mipaquete.com/static/media/logo-white.77acae44.svg"
                      alt="Imagen de envio mipaquete.com"
                      :width="85"
                    />
                  </router-link>
                </div>
              </div>
              <div v-else class="content-mipaquete">
                <div class="flex flex-row items-end">
                  <p class="mr-4">Ya se genero el envío con</p>
                  <img
                    loading="lazy"
                    src="https://centrodenovedades.mipaquete.com/static/media/imagotype.3d75c2b1.svg"
                    alt="Imagen de logo mipaquete.com"
                    :width="80"
                  />
                </div>
                <!-- <div>
                  <router-link
                    :to="
                      `/integraciones/mi-paquete?order_id=${data.venta.id}&pre_envio=true&order_mipaquete=${this.order_mipaquete}`
                    "
                    class=" flex flex-row items-end mx-5 my5 btn_mipaquete cursor-pointer"
                  >
                    <p class="mr-3">Ver</p>
                  </router-link>
                </div> -->
              </div>
            </div>
            <div
              v-if="data?.venta?.usuario?.rol === 20"
              class="flex flex-col items-end"
            >
              <div>
                <div
                  class="w-full max-w-lg mx-auto bg-gradient-to-tl from-green-600 to-green-900 shadow-lg rounded-lg overflow-hidden border border-green-600"
                >
                  <div
                    class="w-full grid grid-cols-2 justify-center items-center px-6 py-8"
                  >
                    <div
                      class="w-full flex flex-col justify-between items-start"
                    >
                      <h2 class="text-2xl font-bold text-gray-100 mb-7">
                        Tarjeta Joven
                      </h2>
                      <p class="text-lg text-white">
                        {{ data.venta.usuario.nombre }}
                      </p>
                      <p class="text-sm text-white">
                        {{ data.venta.usuario.email }}
                      </p>
                      <p class="text-sm text-white mb-7">
                        {{ data.venta.usuario.user_info[0].telefono }}
                      </p>
                      <img
                        loading="lazy"
                        src="../assets/cajica/cajica.png"
                        alt="visa logo"
                        class="w-32"
                      />
                    </div>
                    <div class="w-full flex justify-center items-end">
                      <img
                        loading="lazy"
                        src="../assets/cajica/imgCard.png"
                        alt="logoCajica"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="data && data.venta.reseller_id && data.venta.reseller"
              class="w-full px-4 py-4 border border-yellow-600 rounded-md flex justify-between"
            >
              <div class="flex flex-row items-center justify-center">
                <img
                  loading="lazy"
                  src="../assets/shipping.png"
                  alt="Imagen dropshipping"
                  :width="60"
                />
                <p class="ml-4 text-base font-bold">Venta con Dropshipping</p>
              </div>
              <div class="flex flex-row">
                <div>
                  <img
                    loading="lazy"
                    :src="`${this.$store.state.configKomercia.url}/users/${data.venta.reseller.foto}`"
                    :width="60"
                    alt="photo user dropshipping"
                  />
                </div>
                <div class="ml-5">
                  <p>
                    <strong>Nombre:</strong> {{ data.venta.reseller.nombre }} -
                    {{ data.venta.reseller.id }}
                  </p>
                  <p>
                    <strong>Correo:</strong> {{ data.venta.reseller.email }}
                  </p>
                  <p>
                    <strong>Teléfono:</strong>
                    {{ data.venta.reseller.user_info[0].telefono }}
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section v-if="tiendaData && data" class="section-responsive">
            <div class="col-sm-4 col-sm-12 col-xs-12 invoice-col-res">
              <h1>Información de la venta</h1>
              <div class="content-right">
                <p class="pull-right">
                  <b>ID: {{ data.venta.id }}</b>
                  <b>Fecha: {{ data.venta.fecha }}</b>
                </p>
              </div>
            </div>
            <div v-if="data.productos.length > 0" class="new-table-responsive">
              <TableProducts :data="data" :is-quotation="!!isQuotation" />
            </div>
            <div v-else>
              <div
                v-if="productDataHoko && data.mensajes.length > 0"
                class="new-table-responsive"
              >
                <p class="main-title">
                  Compra dropshipping (Hoko)
                  <i class="el-icon-refresh" @click="getproductHoko" />
                </p>
                <div>
                  <div
                    v-if="productDataHoko.delivery_state"
                    class="mt-4 flex flex-row items-center"
                  >
                    <p class="title_payments">Estado del proceso con Hoko:</p>
                    <el-tag
                      size="medium"
                      :color="
                        saleStateHoko[productDataHoko.delivery_state]?.color
                      "
                      class="tag-state ml-2"
                    >
                      {{
                        $t(saleStateHoko[productDataHoko.delivery_state].state)
                      }}
                    </el-tag>
                  </div>
                  <div
                    v-if="productDataHoko.courier_id"
                    class="mt-4 flex flex-row items-center"
                  >
                    <p class="title_payments">Estado del proceso con Hoko:</p>
                    <div class="ml-2">
                      <p v-if="productDataHoko.courier_id == 21">
                        Mensajería MEDELLIN RR
                      </p>
                      <p v-else-if="productDataHoko.courier_id == 44">
                        Envía E-commerce CR
                      </p>
                      <p v-else-if="productDataHoko.courier_id == 45">
                        Envía E-commerce CR
                      </p>
                    </div>
                  </div>
                  <div class="mt-4">
                    <a
                      v-if="data.mensajes && data.mensajes.length > 0"
                      class="btn_url"
                      :href="`https://hoko.com.co/admin/resources/orders/${parseInt(
                        data.mensajes[0].mensaje
                      )}`"
                      target="_blank"
                      title="Ver detalle de la orden en la página de Hoko"
                    >
                      Ver detalle de la orden Hoko
                    </a>
                  </div>
                </div>
              </div>
              <div v-else-if="data.venta.canal === '6'">
                <p>Shopify</p>
              </div>
              <div v-else>
                <p>
                  Falta información para mostrar el detalle de la compra, por
                  favor contactar al cliente
                </p>
              </div>
            </div>
            <div class="detail-content">
              <h1>Detalles de la venta</h1>
              <div class="state-content-resposive">
                <p>
                  <el-tag
                    size="medium"
                    :color="saleState[data.venta.estado]?.color"
                    effect="dark"
                  >
                    {{ saleState[data.venta.estado].state }}
                  </el-tag>
                </p>
                <p class="edit" @click="mostrarModal(1)">
                  <i class="el-icon-edit-outline"></i> Editar
                </p>
              </div>
              <div class="info-content-detail">
                <p class="personal-data">
                  <span class="title-detail">Nombre</span>
                  <span class="text-detail">
                    {{ data.venta.usuario.nombre }}
                  </span>
                </p>
                <p class="personal-data">
                  <span class="title-detail">Fecha</span>
                  <span class="text-detail">
                    {{ data.venta.fecha | moment("MMM DD YYYY") }},
                    {{ data.venta.created_at | moment("h:mm:ss a") }}
                  </span>
                </p>
                <p class="personal-data">
                  <span class="title-detail">Email</span>
                  <span class="text-detail">
                    {{ data.venta.usuario.email }}
                  </span>
                </p>
                <p class="personal-data">
                  <span class="title-detail">Identificación</span>
                  <span class="text-detail">
                    {{ data.venta.usuario.tipo_identificacion }}
                    {{ data.venta.usuario.identificacion }}
                  </span>
                </p>
                <p v-if="data.venta.descuento > 0" class="personal-data">
                  <span class="title-detail">Descuento:</span>
                  <span class="text-detail">
                    -{{ data.venta.descuento | formatCurrency(idCountryStore) }}
                  </span>
                </p>
                <p
                  v-if="data.venta.cupon && data.venta.cupon !== 'null'"
                  class="personal-data"
                >
                  <span class="title-detail">Cupón descuento:</span>
                  <span class="text-detail">{{ data.venta.cupon }}</span>
                </p>
                <div v-if="!isQuotation" class="pay-method">
                  <p v-if="choicePayment" class="lead">Método de pago</p>
                  <div
                    v-if="choicePayment"
                    class="checkout_summary_data_payments_list"
                  >
                    <div
                      v-if="choicePayment.image"
                      class="checkout_summary_data_payments_item"
                    >
                      <div>
                        <img
                          loading="lazy"
                          :src="choicePayment.image"
                          alt="Imagen metodo de pago"
                        />
                      </div>
                    </div>
                  </div>
                  <h4
                    v-if="choicePayment && choicePayment.title"
                    class="title_payments"
                  >
                    {{ choicePayment.title }}
                  </h4>
                  <p
                    v-if="choicePayment && choicePayment.description"
                    class="subtitle_payments"
                  >
                    {{ choicePayment.description }}
                  </p>
                </div>
              </div>
            </div>
            <div
              v-if="deliveryData && deliveryData.type !== 0"
              class="shipping-content"
            >
              <h1>Información de envío</h1>
              <div class="info-shipping">
                <p v-if="deliveryData.nombre" class="personal-data">
                  <span class="title-detail">Persona que recibe</span>
                  <span class="text-detail">
                    {{ deliveryData.nombre }} {{ deliveryData.apellido }}
                  </span>
                </p>
                <p v-if="deliveryData.celular" class="personal-data">
                  <span class="title-detail">Teléfono</span>
                  <span class="text-detail">{{ deliveryData.celular }}</span>
                </p>
                <p v-if="deliveryData.direccion" class="personal-data">
                  <span class="title-detail">Dirección</span>
                  <span class="text-detail">{{ deliveryData.direccion }}</span>
                </p>
                <p v-if="deliveryData.barrio" class="personal-data">
                  <span class="title-detail">{{ Barrio }}</span>
                  <span class="text-detail">{{ deliveryData.barrio }}</span>
                </p>
                <div
                  v-if="deliveryData.hasOwnProperty('ciudad')"
                  class="city-option1"
                >
                  <p class="personal-data">
                    <span class="title-detail">Ciudad</span>
                    <span class="text-detail">
                      {{ deliveryData.ciudad.nombre_ciu }}
                    </span>
                  </p>
                  <p class="personal-data">
                    <span class="title-detail">Departamento</span>
                    <span
                      v-if="
                        deliveryData.ciudad && deliveryData.ciudad.departamento
                      "
                      class="text-detail"
                    >
                      {{ deliveryData.ciudad.departamento.nombre_dep }}
                    </span>
                  </p>
                </div>
                <div v-else-if="city && city.nombre_ciu" class="city-option2">
                  <p class="personal-data">
                    <span class="title-detail">Ciudad</span>
                    <span class="text-detail">{{ city.nombre_ciu }}</span>
                  </p>
                  <p class="personal-data">
                    <span class="title-detail">Departamento</span>
                    <span class="text-detail">
                      {{ city.departamento.nombre_dep }}
                    </span>
                  </p>
                </div>
                <p class="personal-data">
                  <span class="title-detail">Valor del envío</span>
                  <span class="text-detail">
                    {{
                      data.venta.costo_envio | formatCurrency(idCountryStore)
                    }}
                  </span>
                </p>
              </div>
            </div>
            <div v-else class="non-info">
              <p>No hay información de envío</p>
            </div>
            <div class="total-sale">
              <p>Total Venta</p>
              <p>{{ total | formatCurrency(idCountryStore) }}</p>
            </div>
          </section>
          <el-dialog
            title="Eliminar orden 🛒"
            :visible.sync="outerVisible"
            :modal-append-to-body="false"
            @close="clear"
            width="600px"
          >
            <div v-if="!innerVisible">
              <p class="text-base text-gray-600">
                ¿Estas seguro que desea eliminar la orden de venta
                {{ data.venta.id }}?
              </p>
              <span class="text-sm text-gray-400 mt-3 ml-2">
                Nota: Después de ser eliminado, no se puede recuperar.
              </span>
            </div>
            <div v-else>
              <p class="text-base text-gray-600">
                Ingresa tu correo para eliminar la venta:
              </p>
              <el-input
                v-model="confirmationEmail"
                placeholder="Email"
                class="inputSearch-filt"
                clearable
              ></el-input>
              <p v-if="validate">Correo no valido</p>
            </div>

            <div slot="footer" class="dialog-footer">
              <el-button @click="outerVisible = false">Cancelar</el-button>
              <el-button
                v-if="!innerVisible"
                type="danger"
                @click="innerVisible = true"
              >
                Eliminar
              </el-button>
              <el-button
                v-else
                class="btn-accept"
                type="primary"
                :loading="stateBtn"
                :disabled="stateBtn ? true : false"
                @click="removeSale"
              >
                {{ stateBtn ? "Cargando" : "Aceptar" }}
              </el-button>
            </div>
          </el-dialog>
        </div>
      </div>
      <div class="info-box">
        <div class="content-button">
          <div class="head">
            <h4><strong>Comprador</strong></h4>
            <br />
          </div>
          <div v-if="data.usuario == 30866" class="delivery__content">
            <div v-if="tempData && tempData.state" class="delivery__content">
              <p
                v-if="
                  tempData &&
                  tempData.dataCustomer &&
                  tempData.dataCustomer.nombre
                "
              >
                <b>Nombre:</b>
                {{ tempData.dataCustomer.nombre }}
              </p>
              <p
                v-if="
                  tempData &&
                  tempData.dataCustomer &&
                  tempData.dataCustomer.phone
                "
              >
                <b>Identificación:</b>
                {{ tempData.dataCustomer.phone }}
              </p>
              <p
                v-if="
                  tempData &&
                  tempData.dataCustomer &&
                  tempData.dataCustomer.correo
                "
              >
                <b>Correo:</b>
                {{ tempData.dataCustomer.correo }}
              </p>
              <p
                v-if="
                  tempData &&
                  tempData.dataCustomer &&
                  tempData.dataCustomer.identificacion
                "
              >
                <b>Teléfono:</b>
                {{ tempData.dataCustomer.identificacion }}
              </p>
              <p
                v-if="
                  tempData &&
                  tempData.dataCustomer &&
                  tempData.dataCustomer.ciudad
                "
              >
                <b>{{ Ciudad }}:</b>
                {{ tempData.dataCustomer.ciudad }}
              </p>
              <p
                v-if="
                  tempData &&
                  tempData.dataCustomer &&
                  tempData.dataCustomer.barrio
                "
              >
                <b>{{ Barrio }}:</b>
                {{ tempData.dataCustomer.barrio }}
              </p>
              <p
                v-if="
                  tempData &&
                  tempData.dataCustomer &&
                  tempData.dataCustomer.direccion
                "
              >
                <b>Dirección:</b>
                {{ tempData.dataCustomer.direccion }}
              </p>
            </div>
            <div
              v-for="(items, index) in tempData.dataCustomer"
              v-else
              :key="index"
            >
              <p v-if="items.textInput && items.value">
                <b>{{ items.textInput }}</b>
                {{ items.value }}
              </p>
            </div>
          </div>
          <div v-else class="delivery__content">
            <p>
              <b>Nombre:</b>
              {{ data.venta.usuario.nombre }}
            </p>
            <p v-if="data.venta.usuario.identificacion.length < 21">
              <b>Identificación:</b>
              {{ data.venta.usuario.tipo_identificacion }}
              {{ data.venta.usuario.identificacion }}
            </p>
            <p
              v-if="
                data.venta.usuario.user_info[0] &&
                data.venta.usuario.user_info[0].telefono
              "
            >
              <b>Teléfono:</b>
              {{ data.venta.usuario.user_info[0].telefono }}
            </p>
            <p>
              <b>Email:</b>
              {{ data.venta.usuario.email }}
            </p>
          </div>
          <hr />
          <p v-if="!statusHoko" class="w-full font-semibold mb-1">
            Compartir información de venta
          </p>
          <div
            v-if="!statusHoko"
            class="w-full flex flex-row justify-start items-center mb-5"
          >
            <router-link :to="`/ventas/infoVenta?id=${data.venta.id}`">
              <svg
                title="Imprimir"
                xmlns="http://www.w3.org/2000/svg"
                class="h-7 w-7 cursor-pointer"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                @click="showFacturas(true)"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
                />
              </svg>
            </router-link>
            <svg
              v-if="data.usuario != 30866"
              title="WhatsApp"
              class="ml-2 cursor-pointer svg-wsp"
              xmlns="http://www.w3.org/2000/svg"
              height="26px"
              width="26px"
              viewBox="-23 -21 682 682.66669"
              @click="sendWSPMessage"
            >
              <path
                d="m544.386719 93.007812c-59.875-59.945312-139.503907-92.9726558-224.335938-93.007812-174.804687 0-317.070312 142.261719-317.140625 317.113281-.023437 55.894531 14.578125 110.457031 42.332032 158.550781l-44.992188 164.335938 168.121094-44.101562c46.324218 25.269531 98.476562 38.585937 151.550781 38.601562h.132813c174.785156 0 317.066406-142.273438 317.132812-317.132812.035156-84.742188-32.921875-164.417969-92.800781-224.359376zm-224.335938 487.933594h-.109375c-47.296875-.019531-93.683594-12.730468-134.160156-36.742187l-9.621094-5.714844-99.765625 26.171875 26.628907-97.269531-6.269532-9.972657c-26.386718-41.96875-40.320312-90.476562-40.296875-140.28125.054688-145.332031 118.304688-263.570312 263.699219-263.570312 70.40625.023438 136.589844 27.476562 186.355469 77.300781s77.15625 116.050781 77.132812 186.484375c-.0625 145.34375-118.304687 263.59375-263.59375 263.59375zm144.585938-197.417968c-7.921875-3.96875-46.882813-23.132813-54.148438-25.78125-7.257812-2.644532-12.546875-3.960938-17.824219 3.96875-5.285156 7.929687-20.46875 25.78125-25.09375 31.066406-4.625 5.289062-9.242187 5.953125-17.167968 1.984375-7.925782-3.964844-33.457032-12.335938-63.726563-39.332031-23.554687-21.011719-39.457031-46.960938-44.082031-54.890626-4.617188-7.9375-.039062-11.8125 3.476562-16.171874 8.578126-10.652344 17.167969-21.820313 19.808594-27.105469 2.644532-5.289063 1.320313-9.917969-.664062-13.882813-1.976563-3.964844-17.824219-42.96875-24.425782-58.839844-6.4375-15.445312-12.964843-13.359374-17.832031-13.601562-4.617187-.230469-9.902343-.277344-15.1875-.277344-5.28125 0-13.867187 1.980469-21.132812 9.917969-7.261719 7.933594-27.730469 27.101563-27.730469 66.105469s28.394531 76.683594 32.355469 81.972656c3.960937 5.289062 55.878906 85.328125 135.367187 119.648438 18.90625 8.171874 33.664063 13.042968 45.175782 16.695312 18.984374 6.03125 36.253906 5.179688 49.910156 3.140625 15.226562-2.277344 46.878906-19.171875 53.488281-37.679687 6.601563-18.511719 6.601563-34.375 4.617187-37.683594-1.976562-3.304688-7.261718-5.285156-15.183593-9.253906zm0 0"
                fill-rule="evenodd"
              />
            </svg>
            <svg
              title="Abrir en WEB"
              xmlns="http://www.w3.org/2000/svg"
              class="h-7 w-7 ml-2 cursor-pointer svg-web"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              @click="openShareLink"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
              />
            </svg>
          </div>
          <hr v-if="!statusHoko" />
          <!-- <hr> -->
          <!-- <div
          class="invoice__delivery_method"
          v-if="data.venta.direccion_entrega.type"
        > -->
          <div v-if="data.venta.direccion_entrega.type" class="head">
            <h4><strong>Información envío</strong></h4>
            <br />
          </div>
          <div
            v-if="data.venta.direccion_entrega.type"
            class="delivery__content"
          >
            <div v-if="data.venta.delivery_status_id !== null">
              <b class="mr-2">{{ $t("text_ventas_state_shipment") }}:</b>
              <el-tag
                size="medium"
                :color="shippingState[data.venta.delivery_status_id - 1]?.color"
                effect="dark"
              >
                {{ shippingState[data.venta.delivery_status_id - 1].state }}
              </el-tag>
            </div>
            <p
              v-if="
                deliveryData.hasOwnProperty('ciudad') &&
                deliveryData.ciudad.hasOwnProperty('departamento')
              "
            >
              <b>{{ Ciudad }}:</b>
              {{ deliveryData.ciudad.departamento.nombre_dep }} -
              {{ deliveryData.ciudad.nombre_ciu }}
            </p>
            <p v-else-if="city && city.nombre_ciu">
              <b>{{ Ciudad }}:</b>
              {{ city.departamento.nombre_dep }} - {{ city.nombre_ciu }}
            </p>
            <p v-if="deliveryData.direccion">
              <b>Dirección:</b>
              {{ deliveryData.direccion }}
            </p>
            <p v-if="deliveryData.barrio">
              <b>{{ Barrio }}:</b>
              {{ deliveryData.barrio }}
            </p>
            <p v-if="deliveryData.tag">
              <b>Etiqueta:</b>
              {{ deliveryData.tag }}
            </p>
            <p v-if="deliveryData.nombre">
              <b>Recibe:</b>
              {{ deliveryData.nombre }}
              {{ deliveryData.apellido }}
            </p>
            <p v-if="deliveryData.celular">
              <b>Teléfono:</b>
              {{ deliveryData.celular }}
            </p>
            <p>
              <b>Email:</b>
              {{ data.venta.usuario.email }}
            </p>
          </div>
          <div v-else-if="data.usuario == 30866" class="delivery__content">
            <h4><strong>Información de venta</strong></h4>
            <div v-if="data.venta.delivery_status_id !== null">
              <b class="mr-2">Estado:</b>
              <el-tag
                size="medium"
                :color="shippingState[data.venta.delivery_status_id - 1]?.color"
                effect="dark"
              >
                {{ shippingState[data.venta.delivery_status_id - 1].state }}
              </el-tag>
            </div>
            <br />
            Venta generada por
            <i class="fab fa-whatsapp"></i>WhatsApp
          </div>
          <div v-else class="delivery__content">
            <h4><strong>Recogida en tienda</strong></h4>
            <br />
            <p>El comprador pasará a recoger la compra en tu punto de venta</p>
          </div>
          <!-- <br /> -->
          <hr />
          <div
            v-if="data && data.venta && data.venta.transportadora"
            class="delivery__content"
          >
            <div class="head">
              <h4><strong>Información de transportadora</strong></h4>
            </div>
            <div class="info-shipping">
              <p v-if="dataTransporter.name">
                <b>Nombre: </b>
                {{ dataTransporter.name }}
              </p>
              <p v-if="dataTransporter.name">
                <b>Numero guía: </b>
                {{ dataTransporter.guide }}
              </p>
              <p v-if="dataTransporter.link">
                <b>Link guía: </b>
                <a
                  title="Abrir página de la transportadora"
                  :href="dataTransporter.link"
                  target="_blank"
                >
                  {{ dataTransporter.link }}
                </a>
              </p>
            </div>
          </div>
          <hr v-if="data && data.venta && data.venta.transportadora" />
          <div
            v-if="
              [1, 8, 9].indexOf(parseInt(data.venta.estado)) != -1 ||
              [1, 8, 9].indexOf(parseInt(data.venta.estado)) != -4
            "
          >
            <div
              v-if="
                data &&
                data.venta.mi_paquete_pre_envio &&
                data.venta.mi_paquete_pre_envio.length &&
                data.venta.mi_paquete_pre_envio[0].carritos_id
              "
              class="wrapper-envios"
            >
              <!-- <router-link
                :to="
                  `/integraciones/mi-paquete?order_id=${data.venta.id}&pre_envio=true&order_mipaquete=${this.order_mipaquete}`
                "
              >
                <el-button type="primary" plain>
                  mipaquete.com
                </el-button>
              </router-link> -->
            </div>
            <div v-else class="delivery__content">
              <!-- <el-button type="primary" plain @click="redirectQuoteForm"
                >Envíoclick</el-button
              >
              <el-button type="primary" plain @click="redirectDeliveryForm"
                >Mensajeros urbanos</el-button
              > -->
              <div class="head mb-6">
                <h4><strong>Transportadora</strong></h4>
              </div>
              <router-link
                :to="`/integraciones/mi-paquete?order_id=${data.venta.id}&pre_envio=false`"
              >
                <div class="btn_mipaquete2">
                  <p
                    class="flex justify-center items-center"
                    style="height: 30px"
                  >
                    mipaquete.com
                  </p>
                </div>
              </router-link>
              <el-button
                class="otherTransporter"
                @click="redirectOtherDelivery"
              >
                Información de transportadora
              </el-button>
            </div>
          </div>
          <hr v-if="[1, 8, 9].indexOf(parseInt(data.venta.estado)) != -1" />
          <el-button
            v-if="this.data.venta.metodo_pago === '26'"
            style="margin-bottom: 6px"
            type="danger"
            @click="openDialogRemoveAddi"
          >
            Cancelar pago Addi
          </el-button>
          <el-button type="primary" @click="mostrarModal(1)">
            Actualizar {{ $t("text_ventas_state_sales") }}
          </el-button>
          <el-button
            style="margin-top: 3px"
            type="warning"
            plain
            @click="mostrarModal(2)"
          >
            Actualizar {{ $t("text_ventas_state_shipment") }}
          </el-button>

          <el-button
            style="margin-top: 3px"
            type="danger"
            plain
            @click="remove"
          >
            Eliminar Venta
          </el-button>
        </div>
      </div>
      <el-dialog
        class="wrapper-dialog"
        custom-class
        :visible.sync="isOn"
        append-to-body
        :modal-append-to-body="false"
        :show-close="false"
      >
        <div
          class="rounded-lg bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5"
        >
          <div class="p-5 sm:p-8">
            <div class="-m-3 p-3 flow-root rounded-md">
              <span class="flex items-center justify-between">
                <span class="text-base font-medium text-gray-100">
                  Información adicional de la transportadora
                </span>
                <button
                  class="ml-3 inline-flex items-center px-3 py-0.5 rounded-full text-xs font-medium leading-5 bg-indigo-100 text-indigo-800 hover:bg-indigo-700 hover:text-white transition-all duration-300"
                  @click="isOn = !isOn"
                >
                  Cerrar
                </button>
              </span>
            </div>
          </div>
          <div class="w-full flex flex-col px-5 sm:px-8 py-4">
            <div class="w-full grid grid-cols-3 gap-2">
              <div class="w-full">
                <p class="text-info mb-2">Nombre de la transportadora</p>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Añade la transportadora si aún no está en la lista"
                  placement="top"
                >
                  <el-select
                    v-model="dataTransporter.name"
                    filterable
                    allow-create
                    default-first-option
                    class="inputs-idTienda w-full"
                    placeholder="Nombre transportadora"
                    onkeypress="return ((event.charCode>96 && event.charCode<105) || (event.charCode>47 && event.charCode<58) || (event.charCode>96 && event.charCode<123) || (event.charCode>64 && event.charCode<91) || (event.charCode==32) || (event.charCode==241) || (event.charCode==209))"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.value"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-tooltip>
              </div>
              <div class="w-full">
                <p class="text-info mb-2">Número de guía</p>
                <el-input
                  v-model="dataTransporter.guide"
                  class="inputs-idTienda"
                  placeholder="Número de guía"
                >
                </el-input>
              </div>
              <div class="w-full">
                <p class="text-info mb-2">Link de la guía</p>
                <el-input
                  v-model="dataTransporter.link"
                  class="inputs-idTienda"
                  placeholder="Link de la guía"
                >
                </el-input>
              </div>
            </div>
            <div class="w-full flex justify-end items-center mt-5">
              <button
                class="border-2 border-white text-white rounded-lg px-4 py-2 hover:border-green-komercia-600 hover:text-green-komercia-600 transition-all duration-150 ease-in-out"
                @click="setTransporter()"
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- <Factura
        class="absolute w-full h-full top-0 factura-style"
        v-if="showFactura"
      ></Factura> -->
    </div>
  </div>
</template>

<script>
// import Factura from './printSale.vue'
import axios from "axios";
import TableProducts from "./Invoice/Table";
import TableProductsShopify from "./Invoice/TableShopify.vue";
import states from "../mixins/states.vue";
// import idCloudinary from '../mixins/cloudinaryLink'
import formatCurrency from "../mixins/formatCurrent";
export default {
  components: { TableProducts, TableProductsShopify },
  mixins: [formatCurrency, states],
  props: {
    stateDataOrder: {
      type: Boolean,
      default: null,
    },
    data: {
      type: Object,
      default: null,
    },
    isQuotation: {
      type: [Boolean, Number],
      default: false,
    },
  },
  data() {
    return {
      options: [
        {
          value: "Inter Rapidísimo",
        },
        {
          value: "Servientrega",
        },
        {
          value: "Envía",
        },
        {
          value: "Coordinadora",
        },
        {
          value: "Tcc",
        },
      ],
      dataTransporter: {
        name: "",
        guide: "",
        link: "",
      },
      stateMipaquete: true,
      statusHoko: false,
      Ciudad: "",
      Barrio: "",
      estadoSALE: "",
      direcctionSALE: "",
      urlWSP: "",
      FacturaShow: false,
      getLinkCopy: "",
      tempData: {
        state: false,
        dataCustomer: {},
      },
      tooltip: false,
      modal: false,
      modal2: false,
      dataShopify: [],
      outerVisible: false,
      innerVisible: false,
      confirmationEmail: "",
      validate: false,
      payments: [
        {
          id: "1",
          tag: "payco",
          image: require("../assets/credit.jpg"),
          title: "Tarjeta de Crédito",
          description: "Pago realizado por ePayco",
        },
        {
          id: "2",
          tag: "payco",
          image: require("../assets/pse.jpg"),
          title: "PSE - Cuenta de ahorros y corriente",
          description: "Paga con tu cuenta bancaria o tarjeta débito",
        },
        {
          id: "3",
          tag: "payco",
          image: require("../assets/cash.jpg"),
          title: "Pago en efectivo",
          description: "Mas de 14.000 puntos en todo el país",
        },
        {
          id: "4",
          tag: "consignacion",
          image: "",
          title: "Consignación bancaria",
          description: "Transferencia o consignación a nuestra cuenta bancaria",
        },
        {
          id: "5",
          tag: "efecty",
          image: require("../assets/efecty.png"),
          title: "Giro a Efecty",
          description: "Transferencia o consignación a nuestra cuenta",
        },
        {
          id: "6",
          tag: "tienda",
          image: "",
          title: "Pagar y recoger en la tienda",
          description:
            "Si estas cerca a nuestro negocio, acércate a realizar el pago y recoger tu producto. Escribe abajo en los comentarios cuando vendrías a nuestra tienda para tener tu compra lista.",
        },
        {
          id: "7",
          tag: "convenir",
          image: "",
          title: "Pago a convenir",
          description:
            "Al finalizar tu compra, te contactaremos o puedes comunicarte con nosotros por algunos de nuestros medios de comunicación para que organicemos la forma de pago de tu compra. ",
        },
        {
          id: "8",
          tag: "payco",
          image: require("../assets/safetypay.png"),
          title: "SafetyPay (Banca internacional)",
          description: "Banca y efectivo internacional",
        },
        {
          id: "9",
          tag: "contraentrega",
          image:
            "https://img.komercia.store/komerciaacademico/image/upload/c_scale,q_auto:best,f_auto/v1675790837/komerica/9428582_jc60gj.webp",
          title: "Pago Contra-Entrega",
          description: "Pagas en el momento que recibas tu compra",
        },
        {
          id: "10",
          tag: "mercadopago",
          image: require("../assets/mercadopago.png"),
          title: "Mercadopago",
          description: "Tu cliente ha seleccionado mercadoPago para pagar",
        },
        {
          id: "11",
          tag: "payu",
          image: require("../assets/payu.png"),
          title: "Tarjeta de Crédito",
          description: "Paga con tu tarjeta hasta en 24 cuotas",
        },
        {
          id: "12",
          tag: "payu",
          image: require("../assets/payu.png"),
          title: "Efectivo",
          description: "Tu cliente ha seleccionado PayU para pagar",
        },
        {
          id: "13",
          tag: "payu",
          image: require("../assets/payu.png"),
          title: "PSE - Cuenta de Ahorros y corriente",
          description: "Tu cliente ha seleccionado PayU para pagar",
        },
        {
          id: "14",
          tag: "mercadopago",
          image: require("../assets/mercadopago.png"),
          title: "PSE - Cuenta de Ahorros y corriente",
          description: "Tu cliente ha seleccionado Mercado Pago para pagar",
        },
        {
          id: "15",
          tag: "Daviplata",
          image: require("../assets/daviplata.png"),
          title: "Daviplata",
          description: "Tu cliente ha seleccionado DaviPlata para pagar",
        },
        {
          id: "16",
          tag: "Nequi",
          image: require("../assets/nequi.jpg"),
          title: "Nequi",
          description: "Tu cliente ha seleccionado Nequi para pagar",
        },
        {
          id: "17",
          tag: "Credibanco",
          image: require("../assets/payments/credibanco.png"),
          title: "Credibanco",
          description: "Tu cliente ha seleccionado CrediBanco para pagar",
        },
        {
          id: "18",
          tag: "Wompi",
          image: require("../assets/payments/wompi.png"),
          title: "Wompi",
          description: "Tu cliente ha seleccionado Wompi para pagar",
        },
        {
          id: "19",
          tag: "FLOW",
          image: require("../assets/payments/flow.png"),
          title: "FLOW",
          description: "Tu cliente ha seleccionado FLOW para pagar",
        },
        {
          id: "20",
          tag: "wepay4u",
          image:
            "https://img.komercia.store/komerciaacademico/image/upload/q_auto,f_auto/v1635200779/komerica/cropped-logo-wp4u_fo7gqc.webp",
          title: "Wepay4U",
          description: "Tu cliente ha seleccionado Wepay4U para pagar",
        },
        {
          id: "21",
          tag: "Tucompra",
          image: require("../assets/payments/tucompra.png"),
          title: "Tucompra",
          description: "Tu cliente ha seleccionado TuCompra para pagar",
        },
        {
          id: "22",
          tag: "HokoRecaudo",
          image:
            "https://img.komercia.store/komerciaacademico/image/upload/c_scale,q_auto:best,f_auto/v1644954621/hoko-svg_ygzvza.webp",
          title: "HOKO (Recaudo en efectivo)",
          description:
            "Tu cliente ha seleccionado HOKO (Recaudo en efectivo) para pagar",
        },
        {
          id: "23",
          tag: "PayUCheckout",
          image: require("../assets/payments/Payu.png"),
          title: "PayU",
          description: "Tu cliente ha seleccionado PayU para pagar",
        },
        {
          id: "24",
          tag: "MercadoPago",
          image: require("../assets/payments/mercadopago.png"),
          title: "MercadoPago",
          description: "Tu cliente ha seleccionado MercadoPago para pagar",
        },
        {
          id: "25",
          tag: "EpaycoCheckout",
          image: require("../assets/payments/epayco.png"),
          title: "Epayco",
          description: "Tu cliente ha seleccionado Epayco para pagar",
        },
      ],
      city: {},
      // copyOrdersData: [],
      productDataHoko: {},
      order_mipaquete: "",
      isOn: false,
      stateBtn: false,
    };
  },
  computed: {
    products() {
      return this.data.productos.map((product) => {
        product.getTotal = function () {
          this.total = this.precio_producto * this.unidades;
          return this.total;
        };
        return product;
      });
    },
    showFactura() {
      return this.$store.state.facturaShow;
    },
    // ordersData() {
    //   return this.$store.state.ordersData.data;
    // },
    cities() {
      return this.$store.state.cities;
    },
    tiendaData() {
      return this.$store.state.storeData;
    },
    user() {
      return this.$store.state.configKomercia.usuario;
    },
    choicePayment() {
      return this.payments.find(
        (payment) => payment.id === this.data.venta.metodo_pago
      );
    },
    deliveryData: {
      get() {
        if (
          this.data &&
          this.data.venta.direccion_entrega &&
          this.data.venta.direccion_entrega.value
        ) {
          return this.data.venta.direccion_entrega.value;
        } else {
          return this.data.venta.direccion_entrega;
        }
      },
      set(newValue) {
        return (this.data.venta.direccion_entrega = newValue);
      },
    },
    subtotal() {
      if (this.data) {
        return this.data.productos.reduce((total, product) => {
          return total + product.precio_producto * product.unidades;
        }, 0);
      } else {
        return [];
      }
    },
    shippingCost() {
      if (this.data) {
        return parseInt(this.data.venta.costo_envio) || 0;
      }
      return 0;
    },
    total() {
      return this.subtotal + this.shippingCost;
    },
    // mensajerosurbanos() {
    //   return this.data.venta.domicilio_m_u[0]
    // },
    // mensajerosurbanosLogs() {
    //   if (this.mensajerosurbanos) {
    //     return this.mensajerosurbanos.logs
    //   }
    //   return null
    // },
    // mensajerosurbanosStates() {
    //   return this.$store.state.mensajerosurbanos.states
    // },
    dataHoko() {
      return this.$store.state.dataHoko;
    },
  },
  watch: {
    cities() {
      this.setCity();
    },
    deliveryData() {
      this.setCity();
      this.setText();
    },
    // ordersData() {
    //   if (this.dataHoko && this.dataHoko.statehoko === 1) {
    //     this.getproductHoko();
    //   }
    //   this.copyOrdersData = [...this.ordersData];
    // },
    data: function (newVal) {
      if (this.dataHoko && this.dataHoko.statehoko === 1) {
        this.getproductHoko();
      }
      this.getTransporter();
      if (newVal.usuario == 30866) {
        this.getDataCustomer();
      }
      if (this.data.venta.canal === "6") {
        this.getDataShopify();
      }
    },
  },
  created() {
    // console.log(this.data.venta.estado)
    // console.log([1].indexOf(this.data.venta.estado) != -1)
    this.setText();
    // this.$store.dispatch('GET_CUSTOMERS')
    // if (this.ordersData && this.ordersData.length) {
    //   this.copyOrdersData = [...this.ordersData];
    //   if (this.dataHoko && this.dataHoko.statehoko === 1) {
    //     this.getproductHoko();
    //   }
    // }
    this.getDataCustomer();
    this.getTransporter();
    // this.sendIdMipaquete();
    if (this.$route.query.success == "true" && this.$route.query.codeMi) {
      this.stateMipaquete = false;
    }
  },
  mounted() {
    if (
      this.deliveryData &&
      !Object.prototype.hasOwnProperty.call(this.deliveryData, "ciudad") &&
      this.cities
    ) {
      this.setCity();
    }
    if (this.data.venta.canal === "6") {
      this.getDataShopify();
    }
  },
  destroyed() {
    this.city = {};
  },
  methods: {
    setText() {
      switch (this.tiendaData.informacion_tienda[0].paises_id) {
        //colombia
        case 1:
          this.Ciudad = "Departamento";
          this.Barrio = "Barrio / Zona";
          break;
        //internacional
        case 2:
          this.Ciudad = "State";
          this.Barrio = "City";
          break;
        //Mexico
        case 3:
          this.Ciudad = "Estado";
          this.Barrio = "Cuidad / Colonia / Zona";
          break;
        //Argentina
        case 6:
          this.Ciudad = "Región";
          this.Barrio = "Provincia / Comuna / Sector";
          break;
        //Chile
        case 7:
          this.Ciudad = "Región";
          this.Barrio = "Provincia / Comuna / Sector";
          break;
        //Puerto rico
        case 8:
          this.Ciudad = "Municipio";
          this.Barrio = "Provincia / Comuna / Sector";
          break;
        //peru
        case 9:
          this.Ciudad = "Departamento";
          this.Barrio = "Provincia / Cuidad / Zona";
          break;
        //Panamá
        case 10:
          this.Ciudad = "Provincia";
          this.Barrio = "Distritos / Zona";
          break;
      }
    },
    sendWSPMessage() {
      const formatVariantes = (element) => {
        if (!element.variantes) return "";
        const combiString = JSON.stringify(element.variantes)
          .replace(/"/g, "")
          .replace(/,/g, " - ");
        return `= Variantes: ${combiString}`;
      };

      const formatProduct = (element) => {
        const variantes = formatVariantes(element);
        return `${element.unidades} x ${
          element.producto.nombre
        } ${variantes} -> Valor: ${element.unidades * element.precio_producto}`;
      };

      const productosCart = this.data.productos.map(formatProduct);

      const estadoMapping = {
        0: "Sin Pagar",
        1: "Pagado",
        3: "Cancelada",
        4: "Despachado",
        6: "Entregado",
      };
      this.estadoSALE = estadoMapping[this.data.venta.estado] || "";

      this.direcctionSALE =
        this.data.venta.usuario.user_info[0].direccion || "---";

      const tiendaInfo = this.tiendaData.informacion_tienda[0];
      const ventaInfo = this.data.venta;
      const ciudadInfo = this.tiendaData.ciudad;

      const message = `
        INFORMACIÓN DE VENTA

        ${ventaInfo.tienda_venta.nombre}
        ${ciudadInfo.nombre_ciu} ${ciudadInfo.departamento.nombre_dep}
        Correo: ${tiendaInfo.email_tienda}
        Telefono: (${tiendaInfo.pais.indicativo}) ${tiendaInfo.telefono}

        --------------------------------------
        Venta ${ventaInfo.comentario}

        Nombre: ${ventaInfo.usuario.nombre}
        Identificación: ${ventaInfo.usuario.tipo_identificacion} ${
        ventaInfo.usuario.identificacion
      }
        Telefono: ${ventaInfo.usuario.user_info[0].telefono}
        Correo: ${ventaInfo.usuario.email}
        No. Venta: ${ventaInfo.id}
        Dirección: ${this.direcctionSALE}
        Fecha de pedido: ${ventaInfo.fecha}
        Estado de venta: ${this.estadoSALE}
        --------------------------------------
        PRODUCTO
        ${productosCart.join("%0A")}
        --------------------------------------
        VENTA TOTAL

        Subtotal: $${this.subtotal}
        Envío: $${ventaInfo.costo_envio}
        --------------------------------------
        Total: $${ventaInfo.total}`;

      const phoneNumber = `${
        this.tiendaData.informacion_tienda[0].pais.indicativo
      }${this.obtenerNumeroSinIndicativo(
        this.data.venta.usuario.user_info[0].telefono
      )}`;

      window.open(
        `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
          message
        )}`
      );
    },

    obtenerNumeroSinIndicativo(numero) {
      const regex = /^(\+\d{1,3}\s?)?(\d{10})$/;
      const match = numero.match(regex);
      if (match) {
        return match[2];
        // return { indicativo: match[1], numero: match[2] }
      } else {
        return "";
        // return { indicativo: '', numero: '' }
      }
    },
    showFacturas(value) {
      this.$store.state.facturaShow = value;
    },
    clear() {
      this.innerVisible = false;
      this.confirmationEmail = "";
    },
    remove() {
      this.outerVisible = true;
    },
    async removeSale() {
      this.stateBtn = true;
      const id = this.data.venta.id;
      let inputEmail = this.confirmationEmail.toLowerCase();
      let userEmail = this.user.email.toLowerCase();
      if (inputEmail === userEmail) {
        const { success } = await this.$store.dispatch("DELETE_INVOICE", id);
        if (success) {
          this.success();
          this.innerVisible = false;
          this.outerVisible = false;
          this.stateBtn = false;
          this.$router.push("/ventas/listado");
        }
      } else {
        this.validate = true;
        this.stateBtn = false;
      }
    },
    success() {
      this.$message({
        message: "La venta ha sido eliminada.",
        type: "success",
      });
    },
    successState() {
      this.$message({
        message: "El estado ha sido actualizado.",
        type: "success",
      });
    },
    setCity() {
      const ciudadId = this.deliveryData?.ciudad_id
        ? this.deliveryData?.ciudad_id
        : this.deliveryData?.ciudadId;
      if (this.cities && ciudadId) {
        this.city = this.cities.find((city) => city.id === ciudadId);
      }
    },
    formatJsonVariant(variants) {
      return JSON.parse(variants);
    },
    // redirectQuoteForm() {
    //   this.$router.push(`/entrega/nuevo?order_id=${this.data.venta.id}`);
    // },
    // redirectDeliveryForm() {
    //   this.$router.push(
    //     `/mensajeros-urbanos/nuevo?order_id=${this.data.venta.id}`
    //   );
    // },
    redirectOtherDelivery() {
      this.isOn = !this.isOn;
    },
    getTransporter() {
      if (this.data?.venta?.transportadora) {
        this.dataTransporter = JSON.parse(this.data.venta.transportadora);
      }
    },
    getDataCustomer() {
      if (this.data.usuario !== 30866) {
        return;
      }

      const mensajes = this.data.mensajes;
      const tempData = this.tempData;

      if (mensajes && mensajes.length > 0) {
        tempData.dataCustomer = JSON.parse(mensajes[0].mensaje);
        const { nombre, phone, identificacion, direccion, barrio, ciudad } =
          tempData.dataCustomer;

        tempData.state = !!(
          nombre &&
          phone &&
          identificacion &&
          direccion &&
          barrio &&
          ciudad
        );
      } else {
        tempData.dataCustomer = null;
        tempData.state = false;
      }
    },

    async setTransporter() {
      try {
        const { data } = await axios.post(
          `${this.$configKomercia.url}/api/admin/ventas/orden/transportadora`,
          {
            id: this.data.venta.id,
            transportadora: JSON.stringify(this.dataTransporter),
          },
          this.$store.state.configAxios
        );
        if (data) {
          this.isOn = false;
          this.$message({
            type: "success",
            message: "Datos guardados correctamente!",
          });
        }
      } catch (error) {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: `<h2><strong>${error.response.data.message}</strong></h2><br/><span>${error.response.data.errors.transportadora[0]}</span>`,
          type: "warning",
        });
      }
    },
    async createOrder() {
      await this.$store.dispatch("UPDATE_ORDER", {
        data: this.data,
        total: this.subtotal,
      });
      this.$notify({
        title: "Cotizacion completada",
        message: "Se ha enviado un correo electronico al cliente",
        type: "success",
      });
      this.$router.push("/ventas/listado");
    },
    mostrarModal(value) {
      const modals = {
        1: "modal",
        2: "modal2",
      };

      if (modals[value]) {
        this[modals[value]] = true;
      }
    },
    closeModal(value) {
      const modals = {
        1: "modal",
        2: "modal2",
      };

      if (modals[value]) {
        this[modals[value]] = false;
      }
    },
    async updateState(index) {
      let params = {
        id: this.data.venta.id,
        estado: this.saleStateShort[index].id,
      };
      const { success, data } = await this.$store.dispatch(
        "UPDATE_INVOICE",
        params
      );
      if (success) {
        this.successState();
        this.data.venta.estado = data.data.estado;
      } else {
        this.$message({
          message: "El estado no ha sido actualizado.",
          type: "error",
        });
      }
    },
    async updateShippingState(value) {
      let params = {
        carrito: this.data.venta.id,
        estado: value,
      };
      const { success } = await this.$store.dispatch(
        "UPDATE_SHIPPING_STATE",
        params
      );
      if (success) {
        this.successState();
        this.data.venta.delivery_status_id = value;
      } else {
        this.$message({
          message: "El estado no ha sido actualizado.",
          type: "error",
        });
      }
    },
    // getMUState(activity) {
    //   let state = {}
    //   if (activity.status_id === 5) {
    //     state = this.mensajerosurbanosStates[activity.status_id][1]
    //   } else {
    //     state = this.mensajerosurbanosStates[activity.status_id][0]
    //   }
    //   return {
    //     ...activity,
    //     ...state,
    //   }
    // },
    getcopyLink() {
      this.getLinkCopy = `${this.getUrlProduct()}/micompra?orden=${
        this.data.venta.id
      }&usuario=${this.data.venta.usuario.identificacion}`;
    },
    copyLink() {
      this.tooltip = true;
      const el = document.createElement("textarea");
      el.value = `${this.getUrlProduct()}/micompra?orden=${
        this.data.venta.id
      }&usuario=${this.data.venta.usuario.identificacion}`;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      setTimeout(() => {
        this.tooltip = false;
      }, 1500);
    },
    openShareLink() {
      if (this.tiendaData.template == 99) {
        window.open(
          `${this.getUrlProduct()}/wa/${this.tiendaData.id}/micompra?orden=${
            this.data.venta.id
          }&usuario=${this.data.venta.usuario.identificacion}`
        );
      } else if (this.data.usuario == 30866) {
        window.open(
          `https://wapi.me/wa/${this.tiendaData.id}/micompra?orden=${this.data.venta.id}&usuario=${this.data.venta.usuario.identificacion}`
        );
      } else {
        window.open(
          `${this.getUrlProduct()}/micompra?orden=${
            this.data.venta.id
          }&usuario=${this.data.venta.usuario.identificacion}`
        );
      }
    },
    getUrlProduct() {
      const suffix = this.tiendaData.template !== 3 ? "store" : "co";
      if (
        this.tiendaData.entidades &&
        this.tiendaData.entidades.length > 0 &&
        this.tiendaData.entidades[0].id == 21
      ) {
        return `https://${this.tiendaData.subdominio}.keepbuy.co`;
      } else {
        if (this.tiendaData.informacion_tienda[0].dominio) {
          return `${this.tiendaData.informacion_tienda[0].dominio}`;
        } else {
          return `https://${this.tiendaData.subdominio}.komercia.${suffix}`;
        }
      }
    },
    async getproductHoko() {
      if (this.data.mensajes && this.data.mensajes.length > 0) {
        let id = parseInt(this.data.mensajes[0].mensaje);
        try {
          const { data } = await axios({
            method: "GET",
            url: `https://hoko.com.co/api/member/order/${id}`,
            headers: {
              "content-type": "multipart/form-data",
              Authorization: `Bearer ${this.dataHoko.token}`,
              "Access-Control-Allow-Origin": "*",
            },
          });
          if (data) {
            this.statusHoko = true;
            this.productDataHoko = data;
          }
        } catch (err) {
          console.log("HOKO Error ruta", err.response.data.error);
        }
      }
    },
    removeState() {
      const index = this.saleStateShort.findIndex(
        (item) => item.id === this.data.venta.estado++
      );
      this.saleStateShort.splice(index, 1);
    },
    // sendIdMipaquete() {
    //   this.ordersData.filter((item) => {
    //     if (item.id == this.data.venta.id) {
    //       this.order_mipaquete = item.mi_paquete[0].id;
    //     }
    //   });
    // },
    getDataShopify() {
      let objeto = {};
      objeto = JSON.parse(
        JSON.stringify(
          JSON.parse(this.data.venta.productos_shopify[0].productos)
        )
      );
      this.dataShopify = objeto;
    },
    getChannelStyle(canal) {
      const index = parseInt(canal) - 1;
      const channel = this.channelBuy[index];

      if (channel) {
        return `font-size: 11px; margin-top: -6px; color: ${channel.color};`;
      } else {
        // Puedes proporcionar un estilo predeterminado o simplemente devolver un string vacío.
        return "font-size: 11px; margin-top: -6px; color: #EF4444;";
      }
    },
    getChannelName(canal) {
      const index = parseInt(canal) - 1;
      const channel = this.channelBuy[index];

      return channel ? channel.name : "ERROR";
    },
    openDialogRemoveAddi() {
      this.$confirm(
        `Deseas cancelar el pago de la orden ${this.data.venta.id}?`,
        "Warning",
        {
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        this.removeOrderAddi();
      });
    },
    async removeOrderAddi() {
      const { success } = await this.$store.dispatch("CANCEL_PAYMENT_ADDI", {
        orderId: this.data.venta.id.toString(),
        amount: this.data.venta.total.toString(),
        // environment: "STAGING",
        environment: "PRODUCTION",
        storeId: this.data.venta.tienda,
      });
      if (success) {
        this.$message({
          message: "El pago de la orden ha sido cancelado.",
          type: "success",
        });
      } else {
        this.$message({
          message:
            "Error al cancelar el pago, por favor usa la plataforma de addi para cancelar.",
          type: "error",
        });
      }
    },
  },
};
</script>

<style scoped>
.otherTransporter {
  color: white;
  /* background: #ef8604; */
  border: 1px solid #2962ff;
  color: #2962ff;
  border-radius: 5px;
  padding: 5px 12px;
  margin-top: 10px;
  text-align: center;
  height: 40px;
}
.btn_mipaquete2 {
  /* background: #ef8604; */
  border: 1px solid #ef8604;
  color: #ef8604;
  border-radius: 5px;
  padding: 5px 12px;
  text-align: center;
}
.btn_mipaquete {
  color: white;
  background: #ef8604;
  border-radius: 5px;
  padding: 5px 12px;
}
.btn_url {
  border: 1px solid var(--purple);
  background: var(--purple);
  color: white;
  padding: 4px 10px;
  border-radius: 3px;
}
.btn_url:hover {
  border: 1px solid var(--green);
  background: var(--green);
  color: var(--purple);
}
.svg-wsp:hover {
  color: #4429b4;
  fill: #4429b4;
}
.svg-web:hover {
  color: #4429b4;
  /* fill: #4429b4; */
}
.factura-style {
  background-color: rgba(0, 0, 0, 0.87);
}
i.fab.fa-whatsapp {
  color: #00bb2d;
  font-size: 20px;
  margin-left: 3px;
  margin-right: 2px;
}
h1,
h4 {
  font-family: "Poppins", sans-serif;
}
.logo-store {
  height: 60px;
  filter: grayscale(100%);
  object-fit: contain;
}
.info-box {
  width: 450px;
  height: 100%;
  margin-left: 15px;
  border-radius: 5px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  position: sticky;
  padding: 30px 12px;
}
.title-container {
  display: flex;
  flex-direction: column;
}
.content-button {
  display: flex;
  flex-direction: column;
}
.content-button button {
  width: 100%;
  margin-left: 0px;
  margin-bottom: 4px;
}
.box-body {
  padding: 0;
}
.main-title {
  font-size: 18px;
  font-weight: bold;
}
.wrapper-container-invoice {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.main-container-invoice {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.wrapper-invoice {
  padding: 30px 30px;
}
.wrapper-invoice-nav {
  padding: 15px 30px;
}
.page-header {
  padding: 5px;
  font-weight: 500;
  border-bottom: 1px solid #eee;
}
.page-header .pull-right {
  font-size: 14px;
}
.invoice-col {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 10px;
}
.invoice-res {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
}
.invoice-header {
  border-bottom: 1px solid #eee;
}
.invoice-info {
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: flex-center;
}
.inputSearch-filt >>> .el-input__inner {
  padding: 0px 15px;
  font-size: 13px;
  border-radius: 10px;
  border: solid 2px #f3f4f6;
  background-color: transparent;
  transition: none;
  max-height: 40px;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  cursor: pointer;
  position: relative;
}
.invoice__delivery_method {
  font-size: 14px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  /* margin: 5px 0; */
  border: 1px solid #d8dde3;
  border-radius: 4px;
  padding: 10px;
}
.delivery_subtitle_payments {
  font-weight: 400;
  line-height: 1;
  font-size: 12px;
  color: #586178;
}
.delivery_method_title {
  font-size: 14px;
  color: #586178;
  font-weight: 600;
}
.delivery__content {
  margin: 0px 0 20px 0;
  /* padding: 10px 15px; */
  /* color: #586178; */
}
.delivery__content p {
  line-height: 1.8;
  font-size: 13px;
}
.payment_method {
  max-width: 450px;
  max-height: 180px;
}
.checkout_summary_data_payments_item {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 5px 0;
  padding: 10px;
  border: 1px solid #d8dde3;
  border-radius: 5px;
  transition: 0.3s;
}
.content-mipaquete {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 5px 0;
  padding: 10px;
  border: 1px solid #d8dde3;
  border-radius: 5px;
  transition: 0.3s;
}
.shipping {
  margin-top: 20px;
}
.shipping__data {
  border: 1px solid #d8dde3;
  border-radius: 5px;
  padding: 10px;
  margin-top: 5px;
}
.shipping__header {
  margin-bottom: 15px;
}
.invoice-payments {
  width: 100%;
  display: grid;
  justify-content: end;
  grid-template-columns: 8fr 4fr;
  grid-column-gap: 20px;
}
.row_value {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid #ddd;
  padding: 10px 0;
}
.title_payments,
.title_shipping {
  font-size: 15px;
  color: #373d43;
  font-weight: 600;
}
.subtitle_payments,
.subtitle_shipping {
  font-size: 13px;
  color: #586178;
}
.subtitle_payments_a {
  font-size: 13px;
  color: rgb(29, 184, 166);
  font-weight: 500;
}
.checkout_summary_data_payments_item.selected {
  border: 1px solid #2962ff;
  border-left: 3px solid #2962ff;
}
.checkout_summary_data_payments_item * {
  pointer-events: none;
}
.checkout_summary_data_payments_item img {
  max-width: 100%;
  max-height: 100px;
  margin-bottom: 0px;
  height: 35px;
}
.checkout_summary_data_payments_item i.done {
  position: absolute;
  top: 10px;
  right: 10px;
}
.checkout_summary_data_payments_item.selected i.done {
  border: 1px solid #2962ff;
  background-color: #2962ff;
  color: #fff;
}
.checkout_summary_data_payments_item:first-child .title {
  margin-bottom: 10px;
}
.invoice-actions {
  display: grid;
  margin: 40px 0;
}
hr {
  margin-bottom: 20px;
}
.form > p:first-child {
  padding-bottom: 10px;
}
.form > p:nth-child(3) {
  color: rgb(255, 65, 65);
  font-size: 12px;
  font-weight: bold;
  margin-top: 5px;
}
.form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 10px;
}
.btn-accept {
  align-self: flex-end;
  margin-top: 20px;
}
.quotation__actions {
  margin: 15px 0;
}
.head {
  width: 100%;
  display: flex;
  margin-bottom: 7px;
}
.invoice-payments {
  margin: 30px 0;
}
.el-button--small {
  justify-self: flex-end;
}
.date-time {
  text-transform: capitalize;
}
.content-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.content-right .pull-right {
  display: flex;
  flex-direction: column;
}
.fondo {
  width: 100%;
  height: 100vh;
  background-color: rgba(64, 64, 64, 0.667);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrapper-modal {
  position: relative;
  max-width: 250px;
  width: 100%;
  height: 350px;
  background: #fff;
  padding: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 5px;
  z-index: 99;
  margin-left: 200px;
}
.mfp-close {
  position: absolute;
  top: 0px;
  right: 8px;
  color: black;
  background: transparent;
  cursor: pointer;
  border: 0;
  font-size: 28px;
  font-family: Arial, Baskerville, monospace;
}
img.mfp-img {
  width: 100%;
  height: auto;
}
.mfp-close:hover {
  transition: all ease 0.3s;
  color: var(--green);
}
.main-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.actual-state {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.actual-state .title-state,
.title-state-change {
  padding-bottom: 10px;
  font-weight: 400;
}
.actual-state .tag-state {
  padding-bottom: 20px;
}
.state-content {
  padding-bottom: 6px;
}
.state-content p {
  cursor: pointer;
}
.tag-state .el-tag {
  cursor: context-menu;
}
.el-tag {
  color: #fff;
}
.el-button ~ .el-button {
  margin-right: 0;
}
.section-responsive {
  display: none;
}
.text-normal {
  font-weight: normal !important;
}
.delivery__content b {
  font-weight: bold;
}
.copy-link {
  /* font-size: 12px; */
  text-decoration: underline !important;
  cursor: pointer;
}
.wrapper-dialog >>> .el-dialog {
  border-radius: 10px;
  width: 50%;
}
.wrapper-dialog >>> .el-dialog__header {
  padding: 0;
}
.wrapper-dialog >>> .el-dialog__body {
  padding: 0;
}
.text-info {
  font-size: 12px;
  font-weight: 500;
  color: #919191;
}
.inputs-idTienda >>> .el-input__inner {
  padding: 0px 15px;
  font-size: 13px;
  border-radius: 10px;
  border: solid 2px #f3f4f6;
  background-color: transparent;
  transition: none;
  max-height: 40px;
  color: #f3f4f6;
}
@media (max-width: 1040px) {
  .wrapper-dialog >>> .el-dialog {
    border-radius: 10px;
    width: 80%;
  }
}
@media (max-width: 767px) {
  .wrapper-invoice-nav {
    padding: 15px 0px;
  }
  .info-box {
    display: none;
  }
  .section-normal {
    display: none;
  }
  .section-responsive {
    display: initial;
    margin-bottom: 10px;
  }
  .wrapper-modal {
    margin-left: 0px;
  }
  .wrapper-invoice {
    padding: 10px 0px;
    background: transparent;
    box-shadow: unset;
  }
  .fondo {
    padding-left: 10px;
    padding-right: 10px;
  }
  .content-right {
    align-items: flex-start;
    flex-direction: row;
    margin-top: 20px;
  }
  .content-right .pull-right {
    flex-direction: row;
    color: #77869e;
  }
  .pull-right b:nth-child(2) {
    margin-left: 40px;
  }
  .pull-right b:nth-child(3) {
    margin-left: 40px;
  }
  .new-table-responsive {
    margin-top: 30px;
  }
  .invoice-col h1 {
    color: black;
    font-size: 18px;
  }
  .detail-content {
    padding: 20px 10px 25px 10px;
    margin-left: -10px;
    margin-right: -10px;
    background-color: var(--background);
  }
  .detail-content h1 {
    color: black;
    margin-bottom: 15px;
    font-size: 18px;
  }
  .state-content-resposive {
    display: flex;
    margin-bottom: 15px;
  }
  .state-content-resposive .edit {
    padding-left: 15px;
    color: var(--purple);
    font-weight: 600;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .state-content-resposive .edit .el-icon-edit-outline {
    font-size: 20px;
    margin-right: 3px;
  }
  .personal-data {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }
  .title-detail {
    color: #0000009e;
    font-size: 13.5px;
    margin-bottom: 3px;
  }
  .text-detail {
    color: black;
  }
  .checkout_summary_data_payments_list {
    display: flex;
  }
  .checkout_summary_data_payments_item {
    width: auto;
    background: #ffffff;
    margin-bottom: 10px;
  }
  .lead {
    color: #0000009e;
    font-size: 13.5px;
    margin-bottom: 10px;
  }
  .title_payments {
    font-size: 14px;
    color: black;
    font-weight: 500;
    /* font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; */
    margin-bottom: 3px;
  }
  .subtitle_payments {
    color: #0000009e;
    font-weight: 500;
    /* font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; */
  }
  .shipping-content {
    padding-top: 25px;
    padding-bottom: 25px;
  }
  .non-info {
    padding-top: 25px;
    padding-bottom: 25px;
  }
  .non-info p {
    color: #0000009e;
  }
  .shipping-content h1 {
    color: black;
    margin-bottom: 15px;
    font-size: 18px;
  }
  .total-sale {
    background: var(--purple);
    position: fixed;
    bottom: 76px;
    z-index: 999999999;
    width: 100%;
    margin-left: -27px;
    display: flex;
    justify-content: space-between;
    padding: 15px 10px;
  }
  .total-sale p:nth-child(1) {
    color: #ffffff;
  }
  .total-sale p:nth-child(2) {
    color: #ffffff;
    font-size: 18px;
  }
  .fa-arrow-left {
    font-size: 20px;
    cursor: pointer;
  }
}
</style>
